import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {DataPatientCaseWorkItemToothModel} from '../../../models/teeth/data-patient-case-work-item-tooth.model';
import {DataPatientCaseWorkItemModel} from '../../../models/accountsReceivable/data-patient-case-work-item.model';
import {TdoTableV2Component} from '../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {TdoTableFooterDataModel} from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-footer-data.model';
import {TdoTableSelectionEvent} from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ARService} from '../../ar/ar.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CaseFormsService} from '../case-forms.service';
import {Globals} from '../../../globals';
import {cfgCaseProcedure} from '../../ar/_models/ar.models';
import {DataARTransactionItemModel} from '../../../models/accountsReceivable/data-ar-transaction-item.model';

@Component({
  selector: 'app-case-item-select',
  templateUrl: './case-item-select.component.html',
  styleUrls: ['./case-item-select.component.css']
})
export class CaseItemSelectComponent implements OnInit {

  @ViewChild(TdoTableV2Component) tdoTable: TdoTableV2Component;
  footerData: TdoTableFooterDataModel[] = [];
  searchPredicate: (data: any, filter: string) => boolean;

  patientCaseId: string;
  caseWorkItems: DataPatientCaseWorkItemModel[] = [];
  selectedCaseWorkItem: DataPatientCaseWorkItemModel;
  transactionItem: DataARTransactionItemModel;
  isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<CaseItemSelectComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private arService: ARService,
    private caseService: CaseFormsService,
    private snackBar: MatSnackBar,
    public globals: Globals,
  ) {
    this.searchPredicate = (dataSearch: DataPatientCaseWorkItemModel, filter: string) => {
      const dataCode: string = dataSearch.ProcedureCode ? dataSearch.ProcedureCode : '';
      const dataDesc: string = dataSearch.Description ? dataSearch.Description : '';
      const dataStatus: string = dataSearch.Status ? dataSearch.Status : '';
      return dataCode.toLowerCase().includes(filter) || dataDesc.toLowerCase().includes(filter) || dataStatus.toLowerCase().includes(filter);
    };
  }

  ngOnInit() {
    this.patientCaseId = this.data.PatientCaseId;
    this.transactionItem = this.data.TransactionItem;
    this.init();
  }

  init() {

    this.isLoading = true;

    if (this.patientCaseId) {
      this.caseService.getCaseWorkItemsByPatientCaseAll(this.globals.currentPatientId).subscribe((data) => {
          const result = data;
          // filter out current transaction item
          result.forEach(a => {
            if (a.CaseWorkItemId !== this.transactionItem.CaseWorkItemId) {
              this.caseWorkItems.push(a);
            }
          });
          this.isLoading = false;
        },
        error => {
          this.isLoading = false;
          this.createMessage('Problem loading case items', 'Error');
        }
      );
    } else {
      this.caseWorkItems = [];
      this.isLoading = false;
      this.createMessage('Problem loading case items', 'Error');
    }
  }

  returnToothList(teeth: DataPatientCaseWorkItemToothModel[]) {
    let list = '';
    if (teeth) {
      if (teeth.length) {
        teeth.forEach(a => {
          list = list + a.Notation + ', ';
        });

        // remove last comma
        list = list.slice(0, -2);
      }
    }

    return list;
  }

  saveSelection() {
    if (this.selectedCaseWorkItem) {
      this.updateTransactionItem(this.selectedCaseWorkItem);
    }
  }

  onRowSelected(event: TdoTableSelectionEvent) {
    const procedure = this.caseWorkItems.find(p => p === event.model);

    if (procedure) {
      procedure.Selected = event.isSelected;

      if (event.isSelected) {
        this.selectedCaseWorkItem = procedure;
      }
    }
  }

  cancel(payload) {
    this.dialogRef.close(payload);
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  updateTransactionItem(selectedCaseWorkItem: DataPatientCaseWorkItemModel) {
    this.isLoading = true;

    this.transactionItem.CaseWorkItemId = this.selectedCaseWorkItem.CaseWorkItemId;
    // assuming these fields should also be updated from the case work item to the transaction item
    this.transactionItem.LOCID = this.selectedCaseWorkItem.LOCID;
    this.transactionItem.Code = this.selectedCaseWorkItem.ProcedureCode;
    this.transactionItem.Description = this.selectedCaseWorkItem.Description;

    this.arService.saveTransactionItem(this.transactionItem)
      .subscribe(response => {
        this.createMessage('Tooth updated', 'Success');
        this.isLoading = false;
        this.cancel(true);
      }, err => {
        this.createMessage('Something went wrong', 'Error');
        this.isLoading = false;
      });
  }
}
